export class OrderFormSubmission {
  commonFields: OrderFormSubmissionField[] = [];
  customFields: OrderFormSubmissionField[] = [];

  constructor(data: any) {
    Object.assign(this, data);
  }
}

export type FieldType = 'text' | 'dropdown' | 'file' | 'checkbox' | 'textarea';

export class OrderFormSubmissionField {
  field_id: string;
  field_type: FieldType;
  label: string;
  description: string;
  answer: boolean | string | string[];
}
